import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: ${({ theme }) => theme.spacing(6)};
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  max-width: 21.2rem;
  width: 100%;

  text-align: center;
`;

export const Header = styled.div`
  font-size: 4rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.grey[400]};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};

  padding-top: ${({ theme }) => theme.spacing(1.5)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.h6)};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Footer = styled.div`
  padding-top: ${({ theme }) => theme.spacing(4)};
`;
